import { TFunction } from "i18next";

export class QuillTranslateToolbar {

    private el: ParentNode;
    private i18n: TFunction;

    constructor(id: string, i18n: TFunction) {
        this.i18n = i18n;
        this.el = document.querySelector(`#${id}`);

        if (this.el) {
            const ed = this.el.querySelector(".ql-editor");
            if (ed) ed.setAttribute("tabindex", "0");

            const buttons = this.el.querySelectorAll(".ql-toolbar button, .ql-toolbar .ql-picker, .ql-toolbar .ql-picker .ql-picker-label");
            if (buttons) buttons.forEach((el) => el.setAttribute("tabindex", "-1"));
        }
    }

    private setToolbarTitle(className: string, title: string) {
        var x = this.el.querySelector(`${className}`);
        if (x) x.setAttribute("title", this.i18n(`Components.QuillEditor.${title}`));
    }

    public translate() {
        if (!this.el) return;

        this.setToolbarTitle(".ql-publication", "Title_Publication");
        this.setToolbarTitle(".ql-image", "Title_Image");
        this.setToolbarTitle(".ql-video", "Title_Video");
        this.setToolbarTitle(".ql-link", "Title_Link");
        this.setToolbarTitle(".ql-bold", "Title_Bold");
        this.setToolbarTitle(".ql-italic", "Title_Italic");
        this.setToolbarTitle(".ql-underline", "Title_Underline");
        this.setToolbarTitle(".ql-strike", "Title_Strike");
        this.setToolbarTitle(".ql-indent[value='-1']", "Title_IdentLeft");
        this.setToolbarTitle(".ql-indent[value='+1']", "Title_IdentRight");
        this.setToolbarTitle(".ql-code-block", "Title_BlockCode");
        this.setToolbarTitle(".ql-blockquote", "Title_BlockQuote");
        this.setToolbarTitle(".ql-clean", "Title_ClearFormat");
        this.setToolbarTitle(".ql-size", "Title_FontSize");
        this.setToolbarTitle(".ql-header", "Title_HeaderSize");
        this.setToolbarTitle(".ql-align", "Title_TextAlign");
        this.setToolbarTitle(".ql-background", "Title_BgColor");
        this.setToolbarTitle(".ql-color", "Title_TextColor");
        this.setToolbarTitle(".ql-list[value='ordered']", "Title_OrderedList");
        this.setToolbarTitle(".ql-list[value='bullet']", "Title_BulletList");
        this.setToolbarTitle(".ql-mention", "Title_Mention");
        this.setToolbarTitle(".ql-direction", "Title_TextDirection");
    }
}